import { Injectable } from '@angular/core';

interface Scripts {
	name: string;
	src: string;
}

declare var document: any;

@Injectable()
export class ScriptLoaderService {
	elementos: any = {
		lhcExterno: {
			elemento: 'script',
			cargado: false,
			tambien_borrar: ['lhc_status_container', 'lhc_container'],
			unico: true,
			tipo: 'text/javascript',
			innerHtml: `var LHCChatOptions = {};
            LHCChatOptions.opt = {widget_height:340,widget_width:300,popup_height:520,popup_width:500,domain:'nyvus3.rs.com.ar'};
            (function() {
            var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;
            var referrer = (document.referrer) ? encodeURIComponent(document.referrer.substr(document.referrer.indexOf('://')+1)) : '';
            var location  = (document.location) ? encodeURIComponent(window.location.href.substring(window.location.protocol.length)) : '';
            po.src = 'https://chat.nyvus.net/index.php/esp/chat/getstatus/(click)/internal/(position)/bottom_right/(ma)/br/(top)/350/(units)/pixels/(leaveamessage)/true/(department)/3/(theme)/5?r='+referrer+'&l='+location;
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);
            })();`,
		},
		lhcInterno: {
			elemento: 'script',
			cargado: false,
			tambien_borrar: ['lhc_status_container', 'lhc_container'],
			unico: true,
			tipo: 'text/javascript',
			innerHtml: `var LHCChatOptions = {};
            LHCChatOptions.attr_prefill = new Array();
            LHCChatOptions.attr = new Array();
            LHCChatOptions.attr_prefill.push({'name':'rol2','value':'Test2'});
            LHCChatOptions.attr_prefill.push({'name':'Rol','value':'Test'});
            LHCChatOptions.attr.push({'name':'rol2','value':'Test2'});
            LHCChatOptions.attr.push({'name':'Rol','value':'Test'});
            LHCChatOptions.opt = {widget_height:340,widget_width:300,popup_height:520,popup_width:500,domain:'nyvus3.rs.com.ar'};
            (function() {
            var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;
            var referrer = (document.referrer) ? encodeURIComponent(document.referrer.substr(document.referrer.indexOf('://')+1)) : '';
            var location  = (document.location) ? encodeURIComponent(window.location.href.substring(window.location.protocol.length)) : '';
            po.src = 'https://chat.nyvus.net/index.php/esp/chat/getstatus/(click)/internal/(position)/bottom_right/(ma)/br/(top)/350/(units)/pixels/(leaveamessage)/true/(department)/2/(theme)/5?r='+referrer+'&l='+location;
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);
            })();`,
		},
	};

	load(name: string) {
		if (this.elementos[name].unico) {
			this.unload(name);
		}
		let element = document.createElement(this.elementos[name].elemento);
		
		element.id = name;
		element.type = this.elementos[name].tipo;
		element.innerHTML = this.elementos[name].innerHtml;
		document.getElementsByTagName('head')[0].appendChild(element);
	}
	unload(name: string) {
		if (document.getElementById(name)) {
			this.remove(name);
			for (
				let index = 0;
				index < this.elementos[name].tambien_borrar.length;
				index++
			) {
				const element = this.elementos[name].tambien_borrar[index];
				this.remove(element);
			}
		}
	}
	private remove(name: string) {
		var element = document.getElementById(name);
		if (element) {
			element.remove();
		}
	}
	isLoaded(name: string) {
		return !!document.getElementById(name);
	}
}
